// @ts-nocheck
import React from 'react';
import { useState, useEffect } from 'react';
import ReactGA from "react-ga4";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Helmet } from 'react-helmet-async';

//ヘッダー
import Header from '../../component/page_parts/header';
// フッター
import Footer from '../../component/page_parts/footer';
import FacilityFixture from './f_fixture';
import FacilityEmployee from './f_employee';
import FacilityBiztrip from './f_biztrip';
import FacilityOffice from './f_office';
import FacilitySupplies from './f_supplies';

import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// パンくずリスト
import TableOfContents from "../../component/page_parts/common/table_of_contents";

function Facility() {

  // GAID
  const gaId = process.env.REACT_APP_GA_ID;

  const [explanationChangeValue, setExplanationChangeValue] =
    useState<string>('8');

  // ボタンクリックActive処理
  const selectCategory = (value) => (e) => {
    setExplanationChangeValue(value);

    //全てのbtnToggleのis-activeを外す
    const btnToggleAll = document.querySelectorAll(".btnToggle");
    btnToggleAll.forEach((btnToggle) => {
      btnToggle.classList.remove("is-active");
    });

    //クリックしたbtnToggleにis-activeを付与
    const btnToggle = document.getElementById(value);
    btnToggle.classList.add("is-active");

    var element = document.getElementById(e.target.id);
    var userName = localStorage.getItem("user_name");
    console.log(element?.textContent);
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: "event",
      eventCategory: userName,
      eventAction: '社内のこと-タブ切り替え',
      eventLabel: element?.textContent,
    });
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const videoButtonOne = [
    '【動画】等級制度について　0:30',
    '【動画】役割等級定義　1:30',
    '【動画】昇降格ルール　3:26',
    '【動画】等級制度について　2:54',
    '【動画】等級制度について　0:36',
    '【動画】等級制度について　2:45',
    '【動画】等級制度について　2:45',
    '【動画】等級制度について　2:45',
  ];

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  var element = document.getElementById("1");
  var userName = localStorage.getItem("user_name");
  ReactGA.initialize(gaId);
  ReactGA.send({
    hitType: "event",
    eventCategory: userName,
    eventAction: '社内のこと-タブ切り替え',
    eventLabel: element?.textContent,
  });

  return (
    <>
      <Helmet>
        <title>Z-link 社内のこと</title>
      </Helmet>
      <Header />
      <div className="theme-facility theme-facility-top">
        <div className="content-header">
          <div className="container">
            <Row>
              <Col sm={12}>
                <h1 className='page-title type-building'>社内のこと</h1>{/* ページタイトル */}
                <p className="page-description"> 
                麻布台ヒルズの情報や備品・名刺、鍵・社員証・出張など、社内のことはココで解決！</p>{/* ページの説明 */}
              </Col>
            </Row>
          </div>
        </div>
        <TableOfContents />
        <Container className="main-wrapper">
          {/* 初期表示する内容を記載する */}
          <div className='content'>
            <div className='d-flex flex-wrap justify-content-between select-tags'>
              <div className='tag btnToggle px-3 is-active'
                id='8'
                onClick={selectCategory('8')}>
                麻布台ヒルズ情報
              </div>
              <div className='tag btnToggle px-3'
                id='9'
                onClick={selectCategory('9')}>
                備品・名刺
              </div>
              <div className='tag btnToggle px-3'
                id='1'
                onClick={selectCategory('1')}>
                鍵
              </div>
              <div className='tag btnToggle px-3'
                id='3'
                onClick={selectCategory('3')}>
                社員証
              </div>
              <div className='tag btnToggle px-3'
                id='4'
                onClick={selectCategory('4')}>
                出張
              </div>
            </div>
            {explanationChangeValue === '1' ? (
              <div className='contentOne'>
                <FacilityFixture />
              </div>
            ) : (
              <></>
            )}
            {explanationChangeValue === '3' ? (
              <div className='contentOne'>
                <FacilityEmployee />
              </div>
            ) : (
              <></>
            )}
            {explanationChangeValue === '4' ? (
              <div className='contentOne'>
                <FacilityBiztrip />
              </div>
            ) : (
              <></>
            )}
            {explanationChangeValue === '8' ? (
              <div className='contentOne'>
                <FacilityOffice />
              </div>
            ) : (
              <></>
            )}
             {explanationChangeValue === '9' ? (
              <div className='contentOne'>
                <FacilitySupplies />
              </div>
            ) : (
              <></>
            )}
          </div>
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default Facility;
